import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from './ui/dialog';
import { Keyboard } from '@phosphor-icons/react';

const SHORTCUT_GROUPS = [
  {
    title: 'Navigation',
    shortcuts: [
      { keys: ['g', 'd'], label: 'Tableau de bord' },
      { keys: ['g', 'c'], label: 'Contacts' },
      { keys: ['g', 'o'], label: 'Organisations' },
      { keys: ['g', 't'], label: 'Taches' },
      { keys: ['g', 'f'], label: 'Dossiers ESS' },
      { keys: ['g', 'p'], label: 'Paiements' },
      { keys: ['g', 'r'], label: 'Reporting' },
      { keys: ['g', 's'], label: 'Parametres' },
    ],
  },
  {
    title: 'Actions',
    shortcuts: [
      { keys: ['n'], label: 'Nouveau (contexte page)' },
      { keys: ['/'], label: 'Recherche rapide' },
      { keys: ['Ctrl', 'K'], label: 'Palette de commandes' },
      { keys: ['Shift', '?'], label: 'Raccourcis clavier' },
      { keys: ['Esc'], label: 'Fermer dialogue/modale' },
    ],
  },
];

export function ShortcutsDialog() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleHelp = () => setOpen(true);
    window.addEventListener('crm-shortcut-help', handleHelp);
    return () => window.removeEventListener('crm-shortcut-help', handleHelp);
  }, []);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-[440px]" data-testid="shortcuts-dialog">
        <DialogTitle className="flex items-center gap-2 text-[#1A2421]">
          <Keyboard size={20} className="text-[#2D5A4C]" />
          Raccourcis clavier
        </DialogTitle>
        <DialogDescription className="text-xs text-[#5E6D66]">
          Utilisez ces raccourcis pour naviguer plus rapidement.
        </DialogDescription>
        <div className="space-y-5 mt-2">
          {SHORTCUT_GROUPS.map((group) => (
            <div key={group.title}>
              <h3 className="text-[10px] font-semibold text-[#5E6D66] uppercase tracking-wider mb-2">{group.title}</h3>
              <div className="space-y-1.5">
                {group.shortcuts.map((s, i) => (
                  <div key={i} className="flex items-center justify-between py-1">
                    <span className="text-sm text-[#1A2421]">{s.label}</span>
                    <div className="flex items-center gap-1">
                      {s.keys.map((k, ki) => (
                        <React.Fragment key={ki}>
                          {ki > 0 && <span className="text-[10px] text-[#8DB0A1]">+</span>}
                          <kbd className="px-1.5 py-0.5 text-[11px] font-mono font-medium text-[#5E6D66] bg-[#F0EFEB] rounded border border-[#E8E6E1] min-w-[24px] text-center">
                            {k}
                          </kbd>
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
